<template>
  <router-view :key="$route.path"></router-view>
</template>

<script>
import axios from 'axios'
import router from '@/router'
import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
  methods: {
    ...mapActions(useAuthStore, ['logout']),
  },
  mounted() {
    axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      console.error(error)
      const status = error.response?.status
      const message = error.response?.data?.message

      if (status === 401 || status === 419) {
        if (message === 'CSRF token mismatch.') {
          return Promise.reject(error)
        }

        if (status === 401 && error.config?.url === '/logout') {
          router.replace({ name: 'Login' })
          return Promise.reject(error)
        }

        this.logout()
          .catch((logoutError) => { console.error(logoutError) })

        router.replace({ name: 'Login' })
      } else if (status === 403) {
        router.push({ name: 'VerifyEmail' })
      } else if (status === 423) {
        router.push({ name: 'ConfirmPassword' })
      }

      return Promise.reject(error);
    });
  },
}
</script>
